import { Injectable } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';
import { AuthService } from './auth.service';
import { LocalStoreService } from './local-store.service';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private authService: AuthService,
    private store: LocalStoreService,
  ) { }
  private clone: any
  intercept(request: any, next: any) {
    let lang = this.store.getItem('defaultLangId');
    if (!lang) {
      lang = 1;
    }
    if (request.url.includes(environment.apiBaseUrl)) {
      this.clone = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${this.authService.getToken()}`,
          'Accept-Language': lang.toString()
        }
      });
    } else {
      this.clone = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${this.authService.getToken()}`,
          'Accept-Language': lang.toString()
        }
      });
    }

    return next.handle(this.clone);
  }
}
